import { apiClient } from './ApiClient'
import {
  ForwardTicketRequest,
  ForwardTicketResponse,
  TicketForwardingSummary
} from '../types/entities'

export class TicketForwardingService {
  private basePath = '/ticketforwarding'

  /**
   * Forward a ticket to an external email address
   */
  async forwardTicket(
    ticketId: string,
    request: ForwardTicketRequest
  ): Promise<ForwardTicketResponse> {
    return apiClient.post<ForwardTicketResponse>(
      `${this.basePath}/forward/${ticketId}`,
      request
    )
  }

  /**
   * Get forwarding history for a ticket
   */
  async getForwardingHistory(ticketId: string): Promise<TicketForwardingSummary[]> {
    return apiClient.get<TicketForwardingSummary[]>(
      `${this.basePath}/ticket/${ticketId}`
    )
  }
}

// Export singleton instance
export const ticketForwardingService = new TicketForwardingService()
